import React, { useEffect } from 'react';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { validDecimal, validInteger } from 'app/helpers/numberHelper';
import { usePromiseTracker } from 'react-promise-tracker';
import { isNumber } from '../../ModificationsUtils';
import { useDecision } from '@optimizely/react-sdk';
import { ff_placement_ui_mod_min_required_shifts } from 'app/constants/FeatureFlags/Placement/Keys';

export const MinReqHoursMod = () => {
  // @ts-expect-error
  const { t } = useTranslation();
  const { control, getValues, setValue, setError, clearErrors } = useFormContext();
  const isModEdit = useSelector(selectIsEditMod);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const minReqHrs: any = useWatch({ name: 'minReqHours' });
  const minReqShifts: any = useWatch({ name: 'minReqShifts' });
  const [minRequiredShiftsFlag] = useDecision(ff_placement_ui_mod_min_required_shifts);

  useEffect(() => {
    if (isNumber(getValues('minReqHours'))) {
      clearErrors('minReqHours');
    } else {
      setError('minReqHours', { type: 'required' });
    }
  }, []);

  useEffect(() => {
    if (
      minRequiredShiftsFlag.enabled &&
      (minReqShifts === '' || minReqShifts == null || !validInteger(String(minReqShifts), { numberLength: 10 }))
    ) {
      setError('minReqShifts', { type: 'required' });
    } else {
      clearErrors('minReqShifts');
    }
  }, [minReqShifts, clearErrors, setError, minRequiredShiftsFlag.enabled]);

  return (
    <>
      <Grid spacing={4} direction="column" container height="370px">
        <Grid item>
          <Controller
            name="minReqHours"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value, ...rest } }) => (
              <TextField
                value={getValues('minReqHours')}
                variant="filled"
                label={`${t('placement.placementMods.minReqHours')}`}
                onChange={e => {
                  if (validDecimal(e.target.value, { numberLength: 3, decimalLength: 2 })) {
                    setValue('minReqHours', e.target.value, { shouldDirty: true });
                    onChange(e.target.value);
                  }
                }}
                InputLabelProps={{
                  shrink: (minReqHrs || getValues(minReqHrs)) ?? null,
                }}
                InputProps={{
                  readOnly: !isModEdit,
                  style: {
                    pointerEvents: isModEdit || isSaveModApiCalling ? 'auto' : 'none',
                  },
                }}
                disabled={isSaveModApiCalling}
                sx={{ width: '249px', height: '56px', verticalAlign: 'unset' }}
                {...rest}
              />
            )}
          />
        </Grid>
        {minRequiredShiftsFlag.enabled && (
          <Grid item>
            <Controller
              name="minReqShifts"
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { value, onChange, ...rest } }) => (
                <TextField
                  value={value ?? ''}
                  variant="filled"
                  label={`${t('placement.placementMods.minReqShifts')}`}
                  onChange={e => {
                    if (validInteger(e.target.value, { numberLength: 10 }) || e.target.value === '') {
                      onChange(e.target.value);
                    }
                  }}
                  InputProps={{
                    readOnly: !isModEdit,
                    style: {
                      pointerEvents: isModEdit || isSaveModApiCalling ? 'auto' : 'none',
                    },
                  }}
                  disabled={isSaveModApiCalling}
                  sx={{ width: '249px', height: '56px', verticalAlign: 'unset' }}
                  {...rest}
                />
              )}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};
